<template>
  <v-dialog
    v-model="visible"
    max-width="500px"
    @click:outside="close()"
  >
    <v-card>
      <v-card-title class="justify-center title">
        {{title}}
      </v-card-title>
      <v-card-text>
        <v-container class="caption">
          <v-row no-gutters>
            <v-col cols="6">
              <span>Model</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.model}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>MGW</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.max_gross_weight}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Airport</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.input_airport}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Apt Elev.</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.airport_elevation}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Apt Long Rwy</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.apt_longest_rwy}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Apt Long Rwy Lgth</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.apt_longest_rwy_ft}} ft.</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Apt Short Rwy</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.apt_shortest_rwy}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Apt Short Rwy Lgth</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.apt_shortest_rwy_ft}} ft.</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" >
              <span class="red--text font-weight-bold">Input Temp</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.input_temp}}</span>
            </v-col>
          </v-row>
          <!-- <v-row no-gutters>
            <v-col cols="6">
              <span>Input Dew</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.input_dewpoint}}</span>
            </v-col>
          </v-row> -->
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">Input Baro</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.input_baro}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">Input Wt.</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.input_weight}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">Baro Correct</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.baro_correction}} ft.</span>
            </v-col>
          </v-row>
          <!-- <v-row no-gutters>
            <v-col cols="6">
              <span>Dew Correct</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.dewpoint_correction}} ft.</span>
            </v-col>
          </v-row> -->
          <!-- <v-row no-gutters>
            <v-col cols="6">
              <span>PA Rounding</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.pressure_alt_adj_for_rounding}} ft.</span>
            </v-col>
          </v-row> -->
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">Calc. PA</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.calculated_pa}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">Short Field Chart</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.chart_used_for_calcs}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">PA for Chart</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.pa_used_for_takeoff_chart}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">Temp for Chart</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.temp_used_for_charts}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">T/O Distance</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.takeoffdistance}} ft.</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">Land Distance</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.landingdistance}} ft.</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="red--text font-weight-bold">Total Distance</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span class="red--text font-weight-bold">{{data.totalgroundrolldistance}} ft.</span>
            </v-col>
          </v-row>
          <!-- <v-row no-gutters>
            <v-col cols="6">
              <span>T/O Distance Adj</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.takeoffdistancewithsafety}} ft.</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Land Distance Adj</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.landingdistancewithsafety}} ft.</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Total Distance Adj</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.totalgroundrolldistancesafety}} ft.</span>
            </v-col>
          </v-row> -->
          <v-row no-gutters>
            <v-col cols="6">
              <span>Overweight</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.overweight}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>PA Over Limits</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.paoverlimit}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Apt Long Rwy Ok?</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.aptlongrwysafe}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <span>Apt Short Rwy Ok?</span>
            </v-col>
            <v-col cols="6" :class="dataClass">
              <span>{{data.aptshortrwysafe}}</span>
            </v-col>
          </v-row>
        </v-container>
        </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="primary"
          @click="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "ViewCalcs",
      data() {
        return {
          dataClass: 'pl-10'
      }
    },
    props: {
      visible: {type:Boolean, required: true},
      data: {type:Object, required:true},
      title: {type:String, required: true}
    },
    methods:{
      close() {
        this.$emit('close');
      },
    }
  };
</script>
